// Provides the active locale (derived from the URL pathname) to the site
// chrome (header/footer) so they don't each re-derive it. Page components
// receive their locale as an explicit prop instead and don't need this.

import { createContext, useContext, type ReactNode } from "react";
import { useRouterState } from "@tanstack/react-router";
import { localeFromPathname, type Locale } from "./config";

const LocaleContext = createContext<Locale>("da");

export function LocaleProvider({ children }: { children: ReactNode }) {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  return (
    <LocaleContext.Provider value={localeFromPathname(pathname)}>
      {children}
    </LocaleContext.Provider>
  );
}

export function useLocale(): Locale {
  return useContext(LocaleContext);
}
